import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { FiEdit3, FiEye, FiInfo } from "react-icons/fi";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import BootstrapTable from "react-bootstrap-table-next";
import { getMedicalStatusClass, MD_STATUS } from "./Constant";

import BackBtn from "app/Components/CommanComponents/BackBtn";

import { getMedicalList } from "app/_services/ehs/MedicalService";
import {
  isUserRO,
  isUserMM,
  isUserSO,
  isUserInvestigator,
  isUserMedicalOfficer,
} from "../IncidentManagement/Helper";
import {
  capitalLabel,
  medicalFilterFields,
  MEDICAL_REPORT_STATUS,
  MEDICAL_STATUS,
  validateMedicalRowFilter,
} from "./Constant";
import moment from "moment";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import { downloadFileByURL } from "app/_helpers/reactHelper";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import MedicalFilters from "./Component/MedicalFilters";
import { ACTIVE_MODULE } from "app/_constants/constant";
import { capitalizeName } from "app/_helpers/helper";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";
const { SearchBar } = Search;

function MyApprovalActionMedical({
  match: {
    params: { siteId },
  },
}) {
  const [tab, setTab] = useState(
    isUserMedicalOfficer() ? 1 : isUserSO() ? 2 : isUserMM() ? 3 : 0
  );
  const [medicals, setMedicals] = useState([]);
  const [medicalsFilter, setMedicalsFilter] = useState([]);
  const [medicalsTable, setMedicalsTable] = useState([]);
  const [tabCount, setTabCount] = useState({});
  const [showFilter, setShowFilter] = useState(false);
  const [filterForm, setFilterForm] = useState({});
  const [loading, setLoading] = useState(true);
  const onReset = () => setFilterForm({ formA: "" });

  const onChange = ({ target: { name, value } }) => {
    setFilterForm((prev) => {
      if (name === "medicalAssigneeTypeView") {
        prev.assigneeName = "";
        prev.assigneeID = "";
      }
      return { ...prev, [name]: value };
    });
  };

  const showEditIcon = useCallback((row) => {
    let showEdit = false;
    let tabNumber = null;
    if (row?.medicalStatus) {
      if (
        // row?.medicalStatus === MEDICAL_STATUS.due ||
        row?.medicalStatus === MEDICAL_STATUS.inProgress &&
        isUserMedicalOfficer()
      ) {
        showEdit = true;
        tabNumber = 1;
      }

      if (row?.medicalStatus === MEDICAL_STATUS.soReview && isUserSO()) {
        showEdit = true;
        tabNumber = 2;
      }

      if (row?.medicalStatus === MEDICAL_STATUS.mmReview && isUserMM()) {
        showEdit = true;
        tabNumber = 3;
      }
    }

    return { showEdit, tabNumber };
  }, []);

  const downloadPdf = async (id) => {
    // const data = await downloadMedicalCertificate(id);
    downloadFileByURL(
      URL_CONFIG.DEV_URL +
        "global-configuration/ehs-module/download-medical-certificate/" +
        id,
      `medical-certificate-${new Date().toISOString()}.pdf`
    );

    // console.log("data", data);
  };

  const sortableColumn = useMemo(() => {
    const column = [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "locationName",
        text: "Location",
        sort: true,
      },
      {
        dataField: "medicalTestTypeView",
        text: "Exam",
        sort: true,
      },
      {
        dataField: "medicalAssigneeTypeView",
        text: "Staff Type",
        sort: true,
      },
      {
        dataField: "assigneeName",
        text: "Name",
        sort: true,
        formatter: (status, row) => {
          return <div>{capitalizeName(row?.assigneeName)}</div>;
        },
      },
      {
        dataField: "assigneeID",
        text: "ID",
        sort: true,
      },
      {
        dataField: "formA",
        text: "Form A",
        sort: true,
      },
      // {
      //   dataField: "dueDateView",
      //   text: "Due Date",
      //   sort: true,
      //   formatter: (date) => moment(date).format("DD-MM-YYYY"),
      // },
      {
        dataField: "medicalStatusView",
        text: "Status",
        sort: true,
        // formatter: (val) => capitalLabel(val),
        formatter: (status, row) => {
          return <div className={getMedicalStatusClass(status)}>{status}</div>;
        },
      },
      {
        dataField: "medicalResult",
        text: "Report Status",
        sort: true,
        formatter: (val) => (val ? capitalLabel(val) : "In Progress"),
        formatter: (status, row) => {
          return <div className={getMedicalStatusClass(status)}>{status}</div>;
        },
      },
      {
        dataField: "certificateId",
        text: "Certificate",
        sort: true,
        formatter: (id, row) => {
          return (
            <div className="actionIconsGroup">
              {row?.medicalStatus === MEDICAL_STATUS.approved &&
                row?.medicalResult === MEDICAL_REPORT_STATUS.fit &&
                isUserMedicalOfficer() && (
                  <CustomTooltip tooltip={"Certificate"}>
                    <span
                      // href={
                      //   (row?.medicalTestType.toLowerCase() === "sme"
                      //     ? "/health-safety-and-environment/medical-management/sme-certificate/"
                      //     : "/health-safety-and-environment/medical/certificate/") +
                      //   row?.id
                      // }
                      // target="_blank"
                      // rel="noopener noreferrer"
                      onClick={() => downloadPdf(row?.id)}
                      className="icons text-cyanBlue"
                    >
                      <FiInfo style={{ color: "rgb(21 239 21)" }} />
                    </span>
                  </CustomTooltip>
                )}
            </div>
          );
        },
      },
      {
        dataField: "completionDate",
        text: "Exam Date",
        sort: true,
        //formatter: (date, row) => moment(row?.examDate).format("DD-MM-YYYY"),
        formatter: (date, row) =>
          row?.completionDate ? DDMMYYYYFormat(row?.completionDate) : row?.completionDate,
      },

      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          let editFlag = false;

          // if (row?.medicalStatus === MEDICAL_STATUS.approved) editFlag = false;

          if (row?.medicalStatus) {
            if (
              (row?.medicalStatus === MEDICAL_STATUS.due ||
                row?.medicalStatus === MEDICAL_STATUS.inProgress) &&
              isUserMedicalOfficer()
            )
              editFlag = true;

            if (row?.medicalStatus === MEDICAL_STATUS.soReview && isUserSO()) {
              editFlag = true;
            }

            if (row?.medicalStatus === MEDICAL_STATUS.mmReview && isUserMM())
              editFlag = true;
          }

          return (
            <div className="actionIconsGroup">
              <CustomTooltip tooltip={"View"}>
                <Link
                  to={"/health-safety-and-environment/medical/view/" + row.id}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </CustomTooltip>

              {editFlag && (
                <CustomTooltip tooltip={"Edit"}>
                  <Link
                    to={"/health-safety-and-environment/medical/edit/" + row.id}
                    className="icons text-cyanBlue"
                  >
                    <FiEdit3 />
                  </Link>
                </CustomTooltip>
              )}
            </div>
          );
        },
      },
    ];

    return column;
  }, []);

  useEffect(() => {
    const obj = {};
    setMedicalsTable(
      medicals.filter((row) => {
        const { showEdit, tabNumber } = showEditIcon(row);
        if (!obj.hasOwnProperty(tabNumber)) {
          obj[tabNumber] = 1;
        } else {
          obj[tabNumber] += 1;
        }
        return showEdit ? true : false;
      })
    );
    setTabCount(obj);
  }, [medicals, showEditIcon]);

  useEffect(() => {
    // getMedicalList(siteId ? `filter[siteId]=${siteId}` : "").then((response) => {
    //   if (!response?.data) return;
    //   setMedicals(
    //     response.data.map((inc, idx) => ({
    //       ...inc,
    //       locationName: inc?.ehsSite ? inc?.ehsSite?.name : "",
    //       sid: idx + 1,
    //     }))
    //   );
    // });

    const fetchData = async () => {
      try {
        const response = await getMedicalList(siteId ? `filter[siteId]=${siteId}` : "");
        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }
        setMedicals(
          response.data.map((inc, idx) => ({
            ...inc,
            locationName: inc?.ehsSite ? inc?.ehsSite?.name : "",
            sid: idx + 1,
          }))
        );
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };

    fetchData();
  }, [siteId]);

  useEffect(() => {
    setMedicalsFilter(
      medicalsTable
        ?.filter?.((row) => {
          let showEditIcon = false;

          if (row?.medicalStatus) {
            if (
              tab === 1 &&
              (row?.medicalStatus === MEDICAL_STATUS.due ||
                row?.medicalStatus === MEDICAL_STATUS.inProgress) &&
              isUserMedicalOfficer()
            )
              showEditIcon = true;

            if (tab === 2 && row?.medicalStatus === MEDICAL_STATUS.soReview && isUserSO())
              showEditIcon = true;

            if (tab === 3 && row?.medicalStatus === MEDICAL_STATUS.mmReview && isUserMM())
              showEditIcon = true;
          }

          // if (showEditIcon) showEditIcon = validateRowFilter(filterForm, row);

          console.log("showEditIcon", showEditIcon);

          return showEditIcon;
        })
        ?.filter?.((obj) => {
          return validateMedicalRowFilter(obj, filterForm);
        })
        ?.map((d, i) => ({ ...d, sid: i + 1 }))
    );
  }, [filterForm, medicalsTable, tab]);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <MedicalFilters
        fields={medicalFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChange}
        onReset={onReset}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Personnel Health Management",
            path: "/health-safety-and-environment/medical",
          },
          { name: "My Approval Actions" },
        ]}
        module={ACTIVE_MODULE.personnelHealthManagement}
      />
      <br />
      <br />
      <div className="card p-3">
        <div className="simple-card-title cardCustomHeader">
          <h3 class="text-capitalize mb-1">My Approval Actions</h3>
          <FilterBtn setShowFilter={setShowFilter} />

          {/* <button
          className="btn btn-outline-primary filterBtn"
          onClick={() => {
            setShowFilter((prev) => !prev);
          }}
        >
          <i className="i-Filter-2"></i>Filter
        </button> */}

          <BackBtn url={"/health-safety-and-environment/medical"} />
        </div>

        <div className="healthSafetyEnvironmentWrapper EHS_module_tabber mb-3">
          <div className="hseMenuLinks card">
            {isUserMedicalOfficer() && (
              <a
                href
                onClick={() => setTab(1)}
                className={`pointer${tab === 1 ? " active" : ""}`}
              >
                Medical Officer ({tabCount[1] || 0})
              </a>
            )}

            {isUserSO() && (
              <a
                href
                onClick={() => setTab(2)}
                className={`pointer${tab === 2 ? " active" : ""}`}
              >
                Safety Officer ({tabCount[2] || 0})
              </a>
            )}

            {isUserMM() && (
              <a
                href
                onClick={() => setTab(3)}
                className={`pointer${tab === 3 ? " active" : ""}`}
              >
                Mines Manager ({tabCount[3] || 0})
              </a>
            )}
          </div>
        </div>
        {/* <ToolkitProvider
        striped
        keyField="id"
        data={medicalsFilter}
        columns={sortableColumn}
      >
        {(props) => (
          <>
            
            <div className="d-flex align-items-center justify-content-between pb-3">
              <SearchBar {...props.searchProps} className="mb-0" />
            </div>
            <div className="table-responsive material-master-table medicalTable">
              <BootstrapTable
                rowStyle={rowStyle}
                {...props.baseProps}
                bootstrap4
                noDataIndication={"Table is empty"}
              />
            </div>
          </>
        )}
      </ToolkitProvider> */}
        {!loading ? (
          <SearchBootstrapTable
            searchKey={"myApprovalActionMedicalDesktopSearch"}
            data={medicalsFilter}
            columns={sortableColumn}
            tableBeforeSearch={tableToolbarBeforeView}
            // tableToolbarView={tableToolbarView}
            // downloadPermission={"global_globalConfiguration_download"}
            tableKey="myApprovalActionMedical"
          />
        ) : (
          <NetZeroLoader />
        )}
      </div>
    </>
  );
}

export default MyApprovalActionMedical;
